export const maincolor = '#522e90';

export const name = "Nikhil Malhotra";
export const email = "nikhil.malhotra42@gmail.com";
export const phonenum = "519-731-3123";
export const github = "https://github.com/NikhilM42";
export const linkedin = "https://www.linkedin.com/in/nikhilm42/";

export const navbarmenu = ["ABOUT" ,"KNOWLEDGE", "CURRENT", "EXPERIENCE", "PROJECTS"];

export const languages = [
  {
    "name":"C++",
    "level":3,
    "comment":"I have never had to use this in a professional setting aside from a Co-op at Blackberry, originally coding in C++ 98. I'm updating this skill by going through a textbook into C++ 11/14. I'll jump into a personal project shortly after, probably something robot related.",
    "img":"/img/cpluspluslogo.png"
  },
  {
    "name":"Python",
    "level":3,
    "comment":"I started learning Python as I had heard a lot about it by word of mouth. This was quite a fun and straight forward language. It definitely pushes and promotes good coding practices",
    "img":"/img/pngaaa.com-619138.png"
  },
  {
    "name":"Javascript",
    "level":3,
    "comment":"I got into Javascript by accident through a co-op where I needed to generate a mvp website. I didn't come back to it until recently when I was exploring the best way to interface with AutoCAD. I'm glad I came back because it looks like I didn't learn enough.",
    "img":"/img/JavaScript-logo.png"
  },
  {
    "name":"G-Code",
    "level":4,
    "comment":"I ended up learning this at my first role as a Project Engineer. I kept on losing my manufacturing techs as a resource so I ended up having to fix and generate new CNC programs. This language is quite simliar to Assembly and SVG. The language has general codes that all machines understand and machine specific codes that only the machine being worked on will understand.",
    "img":"/img/GCODE_Logo.png"
  },
  {
    "name":"AutoLISP",
    "level":4,
    "comment":"Why someone thought this language should exist as part of the AutoCAD suite baffles me. It is quite simple but too simple I am quite glad that there are other options as the brackets really got to me after a while of coding in the built in IDE, I got severe VBA PTSD flashbacks.",
    "img":"/img/LISP_Logo.png"
  },
  {
    "name":"MATLAB",
    "level":3,
    "comment":"Most of my exposure to this language has been in University, manufacturing doesnt tend to do vector math very often and neither do I. Otherwise I enjoyed working in this language, no crazy quirks and quite powerful",
    "img":"/img/pngegg.png"
  },
  {
    "name":"SQL",
    "level":2,
    "comment":"Databases have been quite touch and go for me. I've never had a project that required a heavy use of SQL so my understanding of the limitations of the technology is limited (no pun intended). I'll end up implementing some kind of highscore system on this website to learn this in more depth.",
    "img":"/img/SQL_Logo.png"
  },
  {
    "name":"Latex",
    "level":2,
    "comment":"A lot of my classmates back in University were using this language for resume building and research papers. I'll admit I wasnt too confident in myself so I stuck with my trusty Word. Recently I decided why not give it a shot with my latest resumes. I have to admit it is quite fun to watch my content just dance into different formats as I switch different variables. However I am probably going to try for a web based resume now.",
    "img":"/img/LATEX_Logo.png"
  },
  {
    "name":"HTML",
    "level":3,
    "comment":"Similiar to Javascript I learned when making the mvp website. I know enough to be dangerous at this point.",
    "img":"/img/HTML_Logo.png"
  },
  {
    "name":"CSS",
    "level":3,
    "comment":"Similiar to Javascript I learned when making the mvp website. I thought I knew enough but I'm now learning the toolsets that make css coding a bit easier.",
    "img":"/img/CSS_Logo.png"
  }
];

export const tools = [
  {

  },
  {

  },
  {
    
  }
];